module.exports = __webpack_public_path__ + "am.no2.1bda78c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/am.no2.jpg
// module id = UZG8
// module chunks = 0